import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export const useBuyCourse = (slug?: string) =>
  useMutation({
    mutationFn: async ({ phone, platform, type }: { type?: string | null; platform?: string; phone?: string }) => {
      const { data } = await $apiV2.post(`/teacher-course/buy/${slug}`, { phone, platform, type });

      return data;
    },
    onSuccess: data => window.open(data?.order, '_self'),
    onError: errorHandler()
  });
